import { TableBody } from '@razorpay/blade/components';
import { SalaryStructure } from 'components/SalaryStructure/types';
import React from 'react';
import SalaryStructuresListTableRow from './SalaryStructuresListTableRow';
import { SalaryStructureDetails } from '../SalaryStructureDetails';
import { FormProvider } from 'forms';
import { SalaryStructureCreationFlow, SalaryStructureFormData } from '../creation';

interface TableContentProps {
  structures: SalaryStructure[];
  onViewDetails: (structureId: string) => void;
}

const SalaryStructuresListTableContent: React.FC<TableContentProps> = ({
  structures,
  onViewDetails,
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
  const closeDrawer = () => setIsDrawerOpen(false);
  const [structureId, setStructureId] = React.useState<string | null>(null);

  const [isEditOpen, setIsEditOpen] = React.useState(false);
  const closeEdit = () => setIsEditOpen(false);

  return (
    <>
      <TableBody>
        {structures.map((structure) => (
          <SalaryStructuresListTableRow
            key={structure.id}
            structure={structure}
            onViewDetails={() => {
              setStructureId(structure.id);
              setIsDrawerOpen(true);
            }}
          />
        ))}
      </TableBody>
      <FormProvider initialState={{ isEditTemplateMode: true } as SalaryStructureFormData}>
        <SalaryStructureDetails
          isDrawerOpen={isDrawerOpen}
          closeDrawer={closeDrawer}
          structureId={structureId}
          onEdit={() => setIsEditOpen(true)}
        />
        <SalaryStructureCreationFlow isOpen={isEditOpen} onClose={closeEdit} />
      </FormProvider>
    </>
  );
};

export default SalaryStructuresListTableContent;
